import {useState} from 'react';
import {Eye,EyeOff} from 'lucide-react';
import type {InputHTMLAttributes} from 'react';

export default function PasswordField(props:InputHTMLAttributes<HTMLInputElement>){
 const[visible,setVisible]=useState(false);
 return <div className="dx-password"><input {...props} type={visible?'text':'password'}/><button type="button" aria-label={visible?'Şifreyi gizle':'Şifreyi göster'} aria-pressed={visible} onClick={()=>setVisible(!visible)}>{visible?<EyeOff size={18}/>:<Eye size={18}/>}</button></div>;
}
